"use client";

import { useEffect } from "react";
import { initDatadogClient } from "@/lib/datadog";

export default function DatadogClientInit() {
  useEffect(() => {
    initDatadogClient();
  }, []);
  return null;
}
